import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const RecipientSelection = ({ onNext, selectedRecipient, onSelectRecipient }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  const mockRecipients = [
  {
    id: 1,
    name: "Sarah Johnson",
    email: "sarah.johnson@email.com",
    country: "United Kingdom",
    currency: "GBP",
    bankName: "Barclays Bank",
    accountNumber: "****1234",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16967a836-1763296280265.png",
    avatarAlt: "Professional headshot of woman with brown hair in white blazer smiling at camera",
    verificationStatus: "verified",
    lastUsed: "2025-11-15"
  },
  {
    id: 2,
    name: "Michael Chen",
    email: "m.chen@email.com",
    country: "Canada",
    currency: "CAD",
    bankName: "Royal Bank of Canada",
    accountNumber: "****5678",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f07c5c46-1763295267585.png",
    avatarAlt: "Professional headshot of Asian man with black hair in dark suit smiling",
    verificationStatus: "pending",
    lastUsed: "2025-11-10"
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    email: "emma.r@email.com",
    country: "Spain",
    currency: "EUR",
    bankName: "Banco Santander",
    accountNumber: "****9012",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dfbfb501-1763296570605.png",
    avatarAlt: "Professional headshot of Hispanic woman with long dark hair in blue blouse",
    verificationStatus: "verified",
    lastUsed: "2025-11-08"
  }];


  const filteredRecipients = mockRecipients?.filter((recipient) =>
  recipient?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
  recipient?.country?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const handleRecipientSelect = (recipient) => {
    onSelectRecipient(recipient);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'verified':
        return <Icon name="CheckCircle" size={16} className="text-success" />;
      case 'pending':
        return <Icon name="Clock" size={16} className="text-warning" />;
      default:
        return <Icon name="AlertCircle" size={16} className="text-error" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'verified':
        return 'Verified';
      case 'pending':
        return 'Pending Verification';
      default:
        return 'Verification Required';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h2 className="text-2xl font-semibold text-foreground">Select Recipient</h2>
          <p className="text-muted-foreground mt-1">Choose who you want to send money to</p>
        </div>
        <Button
          variant="outline"
          onClick={() => setShowAddForm(!showAddForm)}
          iconName="Plus"
          iconPosition="left">

          Add New Recipient
        </Button>
      </div>
      {/* Search */}
      <div className="max-w-md">
        <Input
          type="search"
          placeholder="Search recipients..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="w-full" />

      </div>
      {/* Add New Recipient Form */}
      {showAddForm &&
      <div className="bg-muted/50 border border-border rounded-lg p-6">
          <h3 className="text-lg font-medium text-foreground mb-4">Add New Recipient</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
            label="Full Name"
            placeholder="Enter recipient's full name"
            required />

            <Input
            label="Email Address"
            type="email"
            placeholder="recipient@email.com"
            required />

            <Input
            label="Country"
            placeholder="Select country"
            required />

            <Input
            label="Currency"
            placeholder="Select currency"
            required />

          </div>
          <div className="flex gap-3 mt-6">
            <Button variant="default">Save Recipient</Button>
            <Button variant="outline" onClick={() => setShowAddForm(false)}>Cancel</Button>
          </div>
        </div>
      }
      {/* Recipients Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredRecipients?.map((recipient) =>
        <div
          key={recipient?.id}
          className={`bg-card border rounded-lg p-4 cursor-pointer transition-all duration-200 hover:shadow-md ${
          selectedRecipient?.id === recipient?.id ?
          'border-primary bg-primary/5' : 'border-border hover:border-primary/50'}`
          }
          onClick={() => handleRecipientSelect(recipient)}>

            <div className="flex items-start space-x-3">
              <Image
              src={recipient?.avatar}
              alt={recipient?.avatarAlt}
              className="w-12 h-12 rounded-full object-cover" />

              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="font-medium text-foreground truncate">{recipient?.name}</h3>
                  {selectedRecipient?.id === recipient?.id &&
                <Icon name="Check" size={16} className="text-primary flex-shrink-0" />
                }
                </div>
                <p className="text-sm text-muted-foreground truncate">{recipient?.email}</p>
                <div className="flex items-center space-x-2 mt-2">
                  <span className="text-sm text-muted-foreground">{recipient?.country}</span>
                  <span className="text-xs text-muted-foreground">•</span>
                  <span className="text-sm font-medium text-foreground">{recipient?.currency}</span>
                </div>
                <div className="flex items-center space-x-1 mt-2">
                  {getStatusIcon(recipient?.verificationStatus)}
                  <span className="text-xs text-muted-foreground">
                    {getStatusText(recipient?.verificationStatus)}
                  </span>
                </div>
                <div className="mt-2">
                  <p className="text-xs text-muted-foreground">{recipient?.bankName}</p>
                  <p className="text-xs text-muted-foreground">{recipient?.accountNumber}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {filteredRecipients?.length === 0 &&
      <div className="text-center py-12">
          <Icon name="Users" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No recipients found</h3>
          <p className="text-muted-foreground mb-4">
            {searchTerm ? 'Try adjusting your search terms' : 'Add your first recipient to get started'}
          </p>
          <Button
          variant="outline"
          onClick={() => setShowAddForm(true)}
          iconName="Plus"
          iconPosition="left">

            Add New Recipient
          </Button>
        </div>
      }
      {/* Continue Button */}
      <div className="flex justify-end pt-6 border-t border-border">
        <Button
          onClick={onNext}
          disabled={!selectedRecipient}
          iconName="ArrowRight"
          iconPosition="right">

          Continue to Quote
        </Button>
      </div>
    </div>);

};

export default RecipientSelection;